/*eslint-disable*/ module.exports = {
  messages: {
    Active: 'Aktív',
    Add: 'Hozzáadás',
    'Add Beer Selection': 'Sörválaszték hozzáadása',
    'Add Beer Servings': 'Söradagok hozzáadása',
    'Add New dish': 'Új étel hozzáadása',
    'Add New item': 'Új tétel hozzáadása',
    'Add Picture': 'Kép hozzáadása',
    'Add QR code': 'QR kód hozzáadása',
    'Add category or element': 'kategória vagy elem hozzáadása',
    'Add dish': 'Fogás hozzáadása',
    'Add meal': 'Étel hozzáadása',
    'Add new menu': 'Új menü hozzáadása',
    'Add other': 'Egyéb hozzáadása',
    'Add soup': 'Leves hozzáadása',
    'Add Star Of The Crafters': 'Add The Brewers Star - BW',
    'Add Colored Star Of The Crafters': 'Add The Brewers Star - color',
    'After creating a category, you can add dishes.':
      'A kategória létrehozása után hozzáadhatsz ételeket.',
    'Alcohol Content': 'Alkoholtartalom',
    All: 'Összes',
    'All languages': 'Összes nyelv',
    Allergens: 'Allergének',
    Amount: 'Méret',
    'Are you sure you want to delete this daily menu?':
      'Biztosan törölni szeretnéd ezt a napi menüt?',
    'Are you sure you want to delete this menu?':
      'Biztosan törölni szeretnéd ezt a menüt?',
    'Available only for A4 size': 'Csak A4-es méretben érhető el',
    'Back to Daily Menu': 'Vissza',
    'Back to Food Menu': 'Vissza',
    'Beer Selection': 'Sörválaszték',
    'Beer Type': 'Sör típus',
    'Beer servings': 'Söradagok',
    Bottom: 'Legutolsó',
    'Brand elements': 'Márkaelemek',
    "Can't upload image": 'A feltöltés nem sikerült',
    Cancel: 'Mégse',
    Categories: 'Kategóriák',
    'Click to select a date': 'Kattints a dátum kiválasztásához',
    Close: 'Bezár',
    Color: 'Szín',
    Continue: 'Folytat',
    'Copy menu': 'menü másolása',
    'Country Of Origin': 'Származási ország',
    'Create Text Block': 'Szövegblokk létrehozása',
    Currency: 'Pénznem',
    'Daily Menu': 'Napi Menü',
    'Daily menu': 'Napi menü',
    Data: 'Adat',
    'Data & Elements': 'Adatok és elemek',
    Delete: 'Törlés',
    'Delete menu': 'Menü törlése',
    'Delete page break': 'Oldaltörés törlése',
    Description: 'Leírás',
    'Description (Optional)': 'Leírás (Opcionális)',
    Desserts: 'Desszertek',
    Designs: 'Dizájn',
    Displays: 'Megjelenítés',
    Duplicate: 'Duplikálás',
    'Duplicate menu': 'Menü duplikálása',
    Edit: 'Szerkeszt',
    'Edit Beer Servings': 'Söradagok szerkesztése',
    'Edit Picture': 'Kép szerkesztése',
    'Edit QR code': 'QR kód szerkesztése',
    'Edit Text Block': 'Szövegblokk szerkesztése',
    'Edit dish': 'Fogás szerkesztése',
    'Edit Star Of The Crafters': 'Edit The Brewers Star - BW',
    'Edit Colored Star Of The Crafters': 'Edit The Brewers Star - color',
    Elements: 'Elemek',
    Email: 'Email',
    'Error!': 'Hiba!',
    Export: 'Exportálás',
    'Export XML': 'Exportálás XML formátumban',
    'Export PDF': 'Exportálás PDF formátumban',
    'Export as JPG': 'Exportálás JPG formátumban',
    Fermentation: 'Fermentáció',
    'Fill in your contact information and we will reach back to you:':
      'Fill in your contact information and we will reach back to you:',
    'Food Combinations': 'Ajánlott ételek',
    'Food cards & Specials': 'Étlapok és specialitások',
    'Food image': 'Étel kép',
    'Generate QR code': 'QR kód generálás',
    Grid: 'Rács',
    'Hover over the tab area to see options for adding categories and elements.':
      'A kategóriák és elemek hozzáadásására vonatkozó lehetőségek megtekintéséhez vidd a kurzort a lap területére',
    Inline: 'Folytatólagos',
    Language: 'Nyelv',
    List: 'Lista',
    'Log in': 'Belépés',
    Login: 'Belépés',
    Logo: 'Logó',
    'Logo (Not available)': 'Logó (Nem elérhető)',
    Logout: 'Kijelentkezés',
    Meals: 'Ételek',
    Menu: 'Menü',
    'Move Block': 'Blokk áthelyezése',
    'Move Dish': 'Fogás áthelyezése',
    'Move Dish position': 'Fogás pozíciójának áthelyezése',
    'Move after block': 'Mozgatás a blokk végére',
    'Move after dish': 'A következő étel után',
    'Move block position': 'Blokk áthelyezése',
    'Move to beginning': 'Mozgatás az elejére',
    Name: 'Név',
    'Name of Restaurant': 'Az étterem neve',
    'Name of category': 'A kategória neve',
    Next: 'Következő',
    'No daily menus were found. Please try to change filters.':
      'Nem találtunk napi menüt.Kérjük próbáld meg a szűrést módosítani',
    'No menus were found. Please try to change filters.':
      'Nem találtunk menüt.Kérjük próbáld meg a szűrést módosítani',
    'One column': 'Egy oszlop',
    'One column with image': 'Egy oszlop képpel',
    Other: 'Egyéb',
    Others: 'Egyebek',
    'Page break': 'Oldaltörés',
    Phone: 'Telefon',
    Picture: 'Kép',
    'Please continue by logging in': 'Kérjük folytassa a bejelentkezéssel',
    Position: 'Pozíció',
    Preview: 'Előnézet',
    Price: 'Ár',
    'Price with soup': 'Ár levessel',
    'Price with meal': 'Ár jóslattal',
    'Price with soup and meal': 'Ár leves nélkül',
    Primary: 'Elsődleges',
    'Secondary Primary': 'Elsődleges',
    Print: 'Nyomtatás',
    'QR code': 'QR kód',
    'Recommend a drink': 'Ital ajánlása',
    Remove: 'Eltávolítás',
    'Remove category': 'Kategória eltávolítása',
    'Remove dish': 'Fogás eltávolítása',
    'Required field': 'Kötelező mezők',
    Save: 'Mentés',
    'Select allergens': 'Allergének választása',
    'Serving Temperature': 'Felszolgálási hőmérséklet',
    'Set to active': 'Aktiválás',
    'Set to inactive': 'Inaktiválás',
    Settings: 'Beállítások',
    Share: 'Megosztás',
    'Show Allergens': 'Allergének megjelenítése',
    'Show Title Page': 'Címlap megjelenítése',
    'Show info': 'Információk megjelenítése',
    'Show name of Restaurant': 'Az étterem nevének megjelenítése',
    'Show portion size': 'Adagok megjelenítése',
    'Show text': 'Szöveg megjelenítése',
    'Show weight / bulk / pieces': 'Súly / mennyiség / darab megjelenítése',
    Size: 'Mennyiség',
    'Secondary Size': 'Méret',
    'size in cl': 'Mennyiség cl-ben',
    'size in ml': 'Mennyiség ml-ben',
    Soup: 'Leves',
    'Soup can be ordered separately': 'Leves külön is rendelhető',
    'Soup priced in main dish': 'A főétel ára levessel együtt értendő',
    Soups: 'Levesek',
    Submit: 'Beállít',
    Taste: 'Íz',
    Templates: 'Sablonok',
    'Text block': 'Szöveg blokk',
    'Tips & Tricks': 'Tippek és Trükkök',
    Title: 'Megnevezés',
    'Two columns': 'Két oszlop',
    'Two columns with image': 'Két oszlop képpel',
    'Type or choose category': 'Gépelje be vagy válasszon kategóriát',
    'Type or choose dish': 'Írja be vagy válasszon ételt',
    'URL address': 'URL cím',
    Untitled: 'Névtelen',
    'Upload image': 'Kép feltöltés',
    'We do not offer anything for this day': 'A mai napra nincsen ajánlatunk',
    'We do not offer:': 'Nem kínálunk:',
    'Weight / bulk / pcs': 'Súly / mennyiség / Db',
    'Weight / bulk / pieces': 'Súly / mennyiség / darab',
    'You might lose some layout settings by this change. Do you wish to continue?':
      'Ezzel a változtatással elveszíthetsz néhány elrendezési beállítást, szeretnéd folytatni?',
    add: 'Hozzáadás',
    'category/element': 'kategória',
    description: 'Leírás',
    item: 'tétel',
    language: 'Nyelv',
    logo: 'logó',
    'remove page': 'oldal eltávolítása',
    units: 'egységek',
    '{0}': [['0']],
    '{label}': [['címke']],
    'Secondary Menu': 'Menü',
    'Secondary Other': 'Egyéb',
    'Logo (Not available)': 'Logó (Nem elérhető)',
    "Can't upload image": ' A feltöltés nem sikerült ',
    'Description not available': 'Leírás nem elérhető',
    'Edit Beer Selection': 'Sörválaszték szerkesztése',
    'Title is required': 'Megnevezés kötelező',
    'Select beers': 'Válassz söröket',
    'Mandatory field': 'Kötelező mező',
    Image: 'Kép',
    'not available': 'nem elérhető',
    'Are you over 18?': 'Elmúltál 18 éves?',
    Yes: 'Igen',
    No: 'Nem',
    'Double Image Block': 'Két képet tartalmazó blokk',
    'Separate price for each item': 'Külön ár levesre és főételre',
    'Soup price is included in the menu': 'Leves ára benne van az étlap árában',
    'Different price for the whole menu': 'Különböző ár az egész menüre',
    'Responsibility Message': 'Felelősségüzenet',
    'ID:': 'ID',
    'Please complete the first 2 steps': 'Kérjük, végezze el az első 2 lépést',
    'Image generation in progress. Please wait. When the download is complete, return to the list of daily menus.':
      'Kép generálása folyamatban. Kérjük, várjon. Amikor a letöltés befejeződött, tér',
    'Share on FB': 'Megosztás Facebookon',
    'Copy menu link': 'Menü link másolása',
    'Are you sure you want to delete this category?':
      'Biztosan törölni szeretnéd ezt a kategóriát?',
    Yes: 'Igen',
    No: 'Nem',
    'Delete item': 'Elem törlése',
    'Edit element': 'Elem szerkesztése',
    'Write a name': 'Írj egy nevet',
    'Create category': 'Kategória létrehozása',
    'Edit category': 'Kategória szerkesztése',
    'Delete category': 'Kategória törlése',
    'Choose a category': 'Válassz egy kategóriát',
    Custom: 'Egyedi',
    'Add item': 'Elem hozzáadása',
    'Add category': 'Kategória hozzáadása',
    'This category already exists.': 'Ez a kategória már létezik.',
    'Something went wrong, probably your file exceeds the allowed post-processing size 10Mb. Please try again with a smaller file.':
      'Valami hiba történt, valószínűleg a fájl mérete meghaladja a megengedett utófeldolgozási méretet 10Mb. Kérjük, próbálja újra kisebb fájllal.',
    'The uploaded file exceeds the maximum allowed size of 10MB. Please upload a smaller file.':
      'A feltöltött fájl meghaladja a megengedett maximális méretet 10MB. Kérjük, töltsön fel kisebb fájlt.',
    Warning: 'Figyelmeztetés',
    'You might loose some layout settings by this change. Do you wish to continue?':
      'Lehetséges, hogy néhány beállítás elveszik ettől a változtatástól. Kívánja folytatni?',
    'Bottom description': 'Alábbi leírás',
    'Logo size': 'Logó mérete',
    Small: 'Kicsi',
    Medium: 'Közepes',
    Large: 'Nagy',
    'Hviezda sladkov': 'The Brewers Star - BW',
    'Farebna hviezda sladkov': 'The Brewers Star - color',
  },
}
